<template>
  <div class="pbr-analysis-content">
    <el-row>
      <el-col :xs="24" :sm="24" :md="12" :lg="12">
        <div class="pbr-analysis-col-div">
          <span class="pbr-analysis-echart-span">{{ $t('charts.analysis.countryComparison.countryComparisonOfProjectQuantity') }}</span>
          <div class="pbr-analysis-echart-div" id="count-contrast"></div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12">
        <div class="pbr-analysis-col-div">
          <span class="pbr-analysis-echart-span">{{ $t('charts.analysis.countryComparison.countryComparisonChartOfProjectAmount') }}</span>
          <div class="pbr-analysis-echart-div" id="amount-contrast"></div>
        </div>
      </el-col>

    </el-row>
    <el-row>
      <el-col :xs="24" :sm="24" :md="12" :lg="12">
        <div class="pbr-analysis-col-div">
          <span class="pbr-analysis-echart-span">{{ $t('charts.analysis.countryComparison.nationalTrendChartOfProjectQuantity') }}</span>
          <div class="pbr-analysis-echart-div" id="count-trend"></div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12">
        <div class="pbr-analysis-col-div">
          <span class="pbr-analysis-echart-span">{{ $t('charts.analysis.countryComparison.nationalTrendChartOfProjectAmount') }}</span>
          <div class="pbr-analysis-echart-div" id="amount-trend"></div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import * as echarts from 'echarts'
  import {chartBarOption, chartColors, xLabelColor, chartLineOption, numberConversion} from './constant'
  import ResizeObserver from 'resize-observer-polyfill'

  let countContrastChart
  let countTrendChart
  let amountContrastChart
  let amountTrendChart

  export default {
    name: 'CountryAnalysis', //国家对比
    props: ['condition', 'exportSuccess'],

    components: {},

    data () {
      return {
        queryParams: {},
        isResize: false,
      }
    },
    computed:{
      isEN () {
        return localStorage.getItem('locale') === 'en'
      },
    },
    mounted () {
      window.addEventListener('resize', () => {
        this.isResize = true;
      })
      this.queryParams = this.condition
      this.initEcharts()
      this.echartTheme()
      this.search()
    },
    methods: {
      getTheme () {
        return this.$store.state.brpaModule.theme || 'white'
      },
      initEcharts () {
        let countContrastDom = document.getElementById('count-contrast')
        countContrastChart = echarts.init(countContrastDom)
        countContrastChart.setOption(chartBarOption)
        countTrendChart = echarts.init(document.getElementById('count-trend'))
        countTrendChart.setOption(chartLineOption)
        amountContrastChart = echarts.init(document.getElementById('amount-contrast'))
        amountContrastChart.setOption(chartBarOption)
        amountTrendChart = echarts.init(document.getElementById('amount-trend'))
        amountTrendChart.setOption(chartLineOption)

        let that = this;
        let countContrastObserver = new ResizeObserver((entries) => {
          if (that.isResize) {
            that.resize();
            if (entries && entries.length > 0 && entries[0].borderBoxSize[0].blockSize > 0) {
              that.isResize = false;
            }
          }
        })
        countContrastObserver.observe(countContrastDom);
      },

      countContrastHandler (obj) {
        if (obj.length <= 0) {
          countContrastChart.clear()
          obj.push({num: 0, name: ''})
          // return ;
        }
        let seriesData = []
        for (let i = 0; i < obj.length; i++) {
          let serData = {}
          serData['name'] = obj[i].name
          serData['type'] = 'bar'
          serData['data'] = [obj[i].num]
          serData['id'] = obj[i].id
          serData['barMaxWidth'] = 30
          serData['itemStyle'] = {color: chartColors[i]}
          seriesData[i] = serData
        }

        const option = {
          title: {
            subtext: this.isEN ? '' : `${this.$t('charts.analysis.unit')} : ${this.$t('charts.analysis.ge')} `,
            top: 15
          },
          legend: {
            type: 'scroll',
            data: obj.map(nation => nation.name),
            textStyle: {
              color: xLabelColor[this.getTheme()],
            }
          },
          xAxis: {
            show: false,
            data: [''],
            // data: obj.map(nation => nation.name),
            axisLabel: {
              color: xLabelColor[this.getTheme()],
              interval: 0,
              rotate: 45,
              formatter: function (params) {
                let val = ''
                let show = localStorage.getItem('locale') === 'cn' ? 4 : 10
                if (params.length > show) {
                  val = params.substr(0, show) + '...'
                  return val
                } else {
                  return params
                }
              }
            },
          },
          yAxis: {
            minInterval: 1,
            boundaryGap: [0, 0.1],
            type: 'value',
            axisLabel: {
              formatter: function (value) {
                return numberConversion(value)
              },
              color: xLabelColor[this.getTheme()],
            }
          },
          series: seriesData,

        }
        countContrastChart.clear()
        countContrastChart.setOption(chartBarOption)
        countContrastChart.setOption(option)
        countContrastChart.on('click', (params) => {
          this.$emit('chartClick', params, 'country')
        })
      },

      countTrendHandler (obj) {
        if (obj.length <= 0) {
          // console.log("1qwertyuiop[");
          // countTrendChart.setOption({}, true);
          // return ;
          obj.push({name: '', nums: [0]})
        }
        let series = []
        for (let i = 0; i < obj.length; i++) {
          let ser = {}
          ser['name'] = obj[i].name
          ser['data'] = obj[i].nums
          ser['type'] = 'line'
          ser['smooth'] = true
          series[i] = ser
        }
        const option = {
          title: {
            subtext: this.isEN ? '' : `${this.$t('charts.analysis.unit')} : ${this.$t('charts.analysis.ge')} `,
            top: 15
          },
          legend: {
            pageIconColor: xLabelColor[this.getTheme()],
            pageTextStyle: {
              color: xLabelColor[this.getTheme()],
            },
            textStyle: {
              color: xLabelColor[this.getTheme()],
            }
          },
          yAxis: {
            minInterval: 1,
            boundaryGap: [0, 0.1],
            type: 'value',
            axisLabel: {
              formatter: function (value) {
                return numberConversion(value)
              },
              color: xLabelColor[this.getTheme()],
            },
            min: function (value) {
              let num = 0
              if (value.min === 0) {
                return num
              } else if (value.min.toString().length < 2) {
                return value.min - 1
              } else if (value.min.toString().length < 3) {
                return value.min - 10
              } else {
                num = 10 ** (value.min.toString().length - 2)
                return Math.floor(value.min / num) * num
              }
            }
          },
          xAxis: {
            data: obj[0].times,
            axisLabel: {
              color: xLabelColor[this.getTheme()],
            },
          },
          series: series,
        }
        countTrendChart.clear()
        countTrendChart.setOption(chartLineOption)
        countTrendChart.setOption(option)
      },

      amountContrastHandler (obj) {
        if (obj.length <= 0) {
          amountContrastChart.clear()
          // return ;
          obj.push({name: '', amount: 0})
        }
        let seriesData = []
        for (let i = 0; i < obj.length; i++) {
          let serData = {}
          serData['name'] = obj[i].name
          serData['type'] = 'bar'
          serData['data'] = [obj[i].amount]
          serData['id'] = obj[i].id
          serData['barMaxWidth'] = 30
          serData['itemStyle'] = {color: chartColors[i]}
          seriesData[i] = serData
        }
        const option = {
          title: {
            subtext: `${this.$t('charts.analysis.unit')} : ${this.$t('charts.analysis.yuan')} `,
            top: 15
          },
          legend: {
            type: 'scroll',
            data: obj.map(nation => nation.name),
            textStyle: {
              color: xLabelColor[this.getTheme()],
            }
          },
          xAxis: {
            data: [''],
            show: false,
            // data: obj.map(nation => nation.name),
            axisLabel: {
              color: xLabelColor[this.getTheme()],
              interval: 0,
              rotate: 45,
              formatter: function (params) {
                let val = ''
                let show = localStorage.getItem('locale') === 'cn' ? 4 : 10
                if (params.length > show) {
                  val = params.substr(0, show) + '...'
                  return val
                } else {
                  return params
                }
              }
            },
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              formatter: function (value) {
                return numberConversion(value)
              },
              color: xLabelColor[this.getTheme()],
            }
          },
          series: seriesData,
        }
        amountContrastChart.clear()
        amountContrastChart.setOption(chartBarOption)
        amountContrastChart.setOption(option)
        amountContrastChart.on('click', (params) => {
          this.$emit('chartClick', params, 'country')
        })
      },

      amountTrendHandler (obj) {
        if (obj.length <= 0) {
          amountTrendChart.clear()
          // return ;
          obj.push({name: '', amount: [0]})
        }
        let series = []
        for (let i = 0; i < obj.length; i++) {
          let ser = {}
          ser['name'] = obj[i].name
          ser['data'] = obj[i].amount
          ser['type'] = 'line'
          ser['smooth'] = true
          series[i] = ser
        }
        const option = {
          title: {
            subtext: `${this.$t('charts.analysis.unit')} : ${this.$t('charts.analysis.yuan')} `,
            top: 15
          },
          legend: {
            pageIconColor: xLabelColor[this.getTheme()],
            pageTextStyle: {
              color: xLabelColor[this.getTheme()],
            },
            textStyle: {
              color: xLabelColor[this.getTheme()],
            }
          },
          xAxis: {
            data: obj[0].times,
            axisLabel: {
              color: xLabelColor[this.getTheme()],
            },
          },

          yAxis: {
            type: 'value',
            axisLabel: {
              color: xLabelColor[this.getTheme()],
              formatter: function (value) {
                return numberConversion(value)
              },
            },
          },
          series: series,
        }
        amountTrendChart.clear()
        amountTrendChart.setOption(chartLineOption)
        amountTrendChart.setOption(option)
      },

      echartTheme () {
        const option = {
          legend: {
            pageIconColor: xLabelColor[this.getTheme()],
            pageTextStyle: {
              color: xLabelColor[this.getTheme()],
            },
            textStyle: {
              color: xLabelColor[this.getTheme()],
            }
          },
          xAxis: {
            axisLabel: {
              color: xLabelColor[this.getTheme()],
            },
          },
          yAxis: {
            axisLabel: {
              color: xLabelColor[this.getTheme()],
            },
          },
        }
        if (countContrastChart) {
          countContrastChart.setOption(option)
        }
        if (countTrendChart) {
          countTrendChart.setOption(option)
        }

        if (amountContrastChart) {
          amountContrastChart.setOption(option)
        }
        if (amountTrendChart) {
          amountTrendChart.setOption(option)
        }
      },

      /**/
      search () {
        countContrastChart.showLoading({
          text: this.$t('loading'),
          maskColor: 'transparent',
          textColor: xLabelColor[this.getTheme()]
        })
        countTrendChart.showLoading({
          text: this.$t('loading'),
          maskColor: 'transparent',
          textColor: xLabelColor[this.getTheme()]
        })
        amountContrastChart.showLoading({
          text: this.$t('loading'),
          maskColor: 'transparent',
          textColor: xLabelColor[this.getTheme()]
        })
        amountTrendChart.showLoading({
          text: this.$t('loading'),
          maskColor: 'transparent',
          textColor: xLabelColor[this.getTheme()]
        })

        let param = {
          from: 'cn',
          module: 'gj', // 模块 gj/hy/wl/xx/sj/fx 分布式国家对比、行业对比、网络声量、信息正负面、商机分析、风险分析  默认为国家对比
        }
        param = Object.assign(param, this.queryParams)
        this.spinShow = true
        this.$pbrAxios.post('/front/analyses/search', param).then((data) => {
          let success = data.success
          if (success) {
            let nationModels = data.result.nationModels
            let nationLineModels = data.result.nationLineModels
            let amountModels = data.result.amountModels
            let amountLineModels = data.result.amountLineModels

            this.countContrastHandler(nationModels)
            this.countTrendHandler(nationLineModels)
            this.amountContrastHandler(amountModels)
            this.amountTrendHandler(amountLineModels)

          } else {

          }
        }).finally(() => {
          this.$emit('closeShow')
          countContrastChart.hideLoading()
          countTrendChart.hideLoading()
          amountContrastChart.hideLoading()
          amountTrendChart.hideLoading()
        })
      },

      /**/
      hsearch () {
        let param = {
          from: 'cn',
          module: 'gj', // 模块 gj/hy/wl/xx/sj/fx 分布式国家对比、行业对比、网络声量、信息正负面、商机分析、风险分析  默认为国家对比
        }
        param = Object.assign(param, this.queryParams)
        console.log(param)
        this.$pbrAxios.post('/front/analyses/hsearch', param).then(data => {
          let success = data.success
          if (success) {
            let nationModels = data.result.nationModels
            let nationLineModels = data.result.nationLineModels
            let amountModels = data.result.amountModels
            let amountLineModels = data.result.amountLineModels
            this.countContrastHandler(nationModels)
            this.countTrendHandler(nationLineModels)
            this.amountContrastHandler(amountModels)
            this.amountTrendHandler(amountLineModels)

          } else {

          }
        }).catch(error => {
          console.log(error)
        }).finally(() => {
          this.$emit('closeShow')
        })
      },

      resize () {
        if (countContrastChart != null) {
          countContrastChart.resize()
        }
        if (countTrendChart != null) {
          countTrendChart.resize()
        }
        if (amountContrastChart != null) {
          amountContrastChart.resize()
        }
        if (amountTrendChart != null) {
          amountTrendChart.resize()
        }
      }
    },
    activated() {
      this.isResize = true;
      this.resize();
    },
    destroyed () {
      window.removeEventListener('resize', () => {
        this.isResize = false;
      })
    },
    watch: {
      '$store.state.brpaModule.theme': {
        handler: function (val) {
          this.echartTheme()
        }
      },
      condition: function (newval) {
        this.queryParams = newval
        if (this.queryParams.id) {
          this.hsearch()
        } else {
          this.search()
        }
      },
      exportSuccess: function(newval){
        this.resize();
      }
    },
  }
</script>

<style scoped>

</style>
